export interface DeliveryChallanRow {
  id: number
  code: string
  /** Resolved via ApiCustomer/GetCustomerById */
  customerName: string
  /** Resolved via SalesOrders/GetSalesOrderById (order code) */
  orderCode: string
  challanDate: string
  expectedDeliveryDate: string
  /** ISO datetime from API `createdDate` */
  createdDate: string
  /** From API `isInvoiceCreated` — when true, single convert is disabled */
  isInvoiceCreated: boolean
}

export type DeliveryChallanLine = {
  /** Sales order line id when `fromOrder` (also used in dcLinesJson as orderLineId) */
  id: number
  itemId: string
  batchId: string
  availableQuantity: number
  quantityReceived: number
  quantityReturn: number
  /** DC line PK from GetDcLinesByDcId — sent as `id` in dcLinesJson on update */
  dcLineId?: number
  /** Explicit SO line id (optional; falls back to `id` when from order) */
  orderLineId?: number
  /** Line came from Dc/GetOrderLines — item/batch cells are read-only labels */
  fromOrder?: boolean
  /** Bonus issued with the sold order line (display-only on save; server rebuilds bonus). */
  isBonus?: boolean
  /** Resolved item name (read-only when fromOrder) */
  itemDisplayName?: string
  /** Resolved batch code (read-only when fromOrder) */
  batchDisplayName?: string
}

export const newDeliveryChallanLine = (): DeliveryChallanLine => ({
  id: 0,
  itemId: '',
  batchId: '',
  availableQuantity: 0,
  quantityReceived: 0,
  quantityReturn: 0,
})

export interface DeliveryChallanDocument {
  id: number
  code: string
  /** Linked sales order id from Dc/GetOrders */
  orderId: string
  /** Snapshot for list/grid (set when order is selected) */
  orderCode: string
  orderReference: string
  orderWarehouseName: string
  orderStatus: string
  customerId: string
  customerName: string
  challanDate: string
  expectedDeliveryDate: string
  /** Last chosen attachment file name (local mock only) */
  attachmentFileName: string
  /** Server-relative path returned by the API (e.g. `Uploads/.../file.png`) — used to build a view link. */
  attachmentFilePath: string
  total: number
  lines: DeliveryChallanLine[]
}
